function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Observable } from '../../utils/observables/observable';
export var DeferredReportingSession = /*#__PURE__*/ function() {
    "use strict";
    function DeferredReportingSession(session, eventQueue) {
        _class_call_check(this, DeferredReportingSession);
        _define_property(this, "session", void 0);
        _define_property(this, "eventQueue", void 0);
        _define_property(this, "adStartedObservable", void 0);
        _define_property(this, "adFinishedObservable", void 0);
        _define_property(this, "adBreakStartedObservable", void 0);
        _define_property(this, "adBreakFinishedObservable", void 0);
        _define_property(this, "adBreakDataReceivedObservable", void 0);
        _define_property(this, "adTrackingReceivedObservable", void 0);
        _define_property(this, "catchupSeekObservable", void 0);
        _define_property(this, "telemetryObservable", void 0);
        _define_property(this, "adPositionObservable", void 0);
        _define_property(this, "assetMetadataUpdateObservable", void 0);
        _define_property(this, "audioTrackWillChangeObservable", void 0);
        _define_property(this, "audioTrackChangedObservable", void 0);
        _define_property(this, "availableAudioTracksChangedObservable", void 0);
        _define_property(this, "availableSubtitlesTracksChangedObservable", void 0);
        _define_property(this, "bitrateChangedObservable", void 0);
        _define_property(this, "encodedFrameRateChangedObservable", void 0);
        _define_property(this, "renderedFrameRateChangedObservable", void 0);
        _define_property(this, "videoTrackChangedObservable", void 0);
        _define_property(this, "cdnSwitchObservable", void 0);
        _define_property(this, "onPlaybackTimelineObservable", void 0);
        _define_property(this, "errorObservable", void 0);
        _define_property(this, "playoutDataObservable", void 0);
        _define_property(this, "sessionEndedObservable", void 0);
        _define_property(this, "sessionStateObservable", void 0);
        _define_property(this, "rebufferStartObservable", void 0);
        _define_property(this, "rebufferEndObservable", void 0);
        _define_property(this, "streamMetadataReceivedObservable", void 0);
        _define_property(this, "playStartObservable", void 0);
        _define_property(this, "seekStartedObservable", void 0);
        _define_property(this, "seekEndedObservable", void 0);
        _define_property(this, "timedMetadataReceivedObservable", void 0);
        _define_property(this, "subtitlesTextChangedObservable", void 0);
        _define_property(this, "subtitlesTrackChangedObservable", void 0);
        _define_property(this, "bitrateCapChangedObservable", void 0);
        _define_property(this, "bitrateCapRequestedObservable", void 0);
        _define_property(this, "volumeChangedObservable", void 0);
        _define_property(this, "warningObservable", void 0);
        _define_property(this, "eventBoundaryObservable", void 0);
        _define_property(this, "pinRequiredObservable", void 0);
        _define_property(this, "pinSuccessObservable", void 0);
        _define_property(this, "userWaitStartedObservable", void 0);
        _define_property(this, "userWaitEndedObservable", void 0);
        _define_property(this, "videoElementCreatedObservable", void 0);
        _define_property(this, "fullscreenChangedObservable", void 0);
        _define_property(this, "clickedObservable", void 0);
        _define_property(this, "muteChangedObservable", void 0);
        _define_property(this, "endOfEventMarkerReceivedObservable", void 0);
        _define_property(this, "sessionRetryStartedObservable", void 0);
        _define_property(this, "sessionRetryEndedObservable", void 0);
        _define_property(this, "sessionRestartStartedObservable", void 0);
        _define_property(this, "sessionRestartEndedObservable", void 0);
        this.session = session;
        this.eventQueue = eventQueue;
        this.adStartedObservable = new Observable();
        this.adFinishedObservable = new Observable();
        this.adBreakStartedObservable = new Observable();
        this.adBreakFinishedObservable = new Observable();
        this.adBreakDataReceivedObservable = new Observable();
        this.adTrackingReceivedObservable = new Observable();
        this.catchupSeekObservable = new Observable();
        this.telemetryObservable = new Observable();
        this.adPositionObservable = new Observable();
        this.assetMetadataUpdateObservable = new Observable();
        this.audioTrackWillChangeObservable = new Observable();
        this.audioTrackChangedObservable = new Observable();
        this.availableAudioTracksChangedObservable = new Observable();
        this.availableSubtitlesTracksChangedObservable = new Observable();
        this.bitrateChangedObservable = new Observable();
        this.encodedFrameRateChangedObservable = new Observable();
        this.renderedFrameRateChangedObservable = new Observable();
        this.videoTrackChangedObservable = new Observable();
        this.cdnSwitchObservable = new Observable();
        this.onPlaybackTimelineObservable = new Observable();
        this.errorObservable = new Observable();
        this.playoutDataObservable = new Observable();
        this.sessionEndedObservable = new Observable();
        this.sessionStateObservable = new Observable();
        this.rebufferStartObservable = new Observable();
        this.rebufferEndObservable = new Observable();
        this.streamMetadataReceivedObservable = new Observable();
        this.playStartObservable = new Observable();
        this.seekStartedObservable = new Observable();
        this.seekEndedObservable = new Observable();
        this.timedMetadataReceivedObservable = new Observable();
        this.subtitlesTextChangedObservable = new Observable();
        this.subtitlesTrackChangedObservable = new Observable();
        this.bitrateCapChangedObservable = new Observable();
        this.bitrateCapRequestedObservable = new Observable();
        this.volumeChangedObservable = new Observable();
        this.warningObservable = new Observable();
        this.eventBoundaryObservable = new Observable();
        this.pinRequiredObservable = new Observable();
        this.pinSuccessObservable = new Observable();
        this.userWaitStartedObservable = new Observable();
        this.userWaitEndedObservable = new Observable();
        this.videoElementCreatedObservable = new Observable();
        this.fullscreenChangedObservable = new Observable();
        this.clickedObservable = new Observable();
        this.muteChangedObservable = new Observable();
        this.endOfEventMarkerReceivedObservable = new Observable();
        this.sessionRetryStartedObservable = new Observable();
        this.sessionRetryEndedObservable = new Observable();
        this.sessionRestartStartedObservable = new Observable();
        this.sessionRestartEndedObservable = new Observable();
        this.session.onAdFinished(this.notifyAdFinished.bind(this));
        this.session.onAdStarted(this.notifyAdStarted.bind(this));
        this.session.onAdBreakFinished(this.notifyAdBreakFinished.bind(this));
        this.session.onAdBreakStarted(this.notifyAdBreakStarted.bind(this));
        this.session.onAdBreakDataReceived(this.notifyAdBreakDataReceived.bind(this));
        this.session.onAdTrackingReceived(this.notifyAdTrackingReceived.bind(this));
        this.session.onCatchupSeek(this.notifyCatchupSeek.bind(this));
        this.session.onAdPositionChanged(this.notifyAdPositionChanged.bind(this));
        this.session.onTelemetry(this.notifyTelemetry.bind(this));
        this.session.onAssetMetadataUpdated(this.notifyAssetMetadataUpdated.bind(this));
        this.session.onAudioTrackWillChange(this.notifyAudioTrackWillChange.bind(this));
        this.session.onBitrateChanged(this.notifyBitrateChanged.bind(this));
        this.session.onEncodedFrameRateChanged(this.notifyEncodedFrameRateChanged.bind(this));
        this.session.onRenderedFrameRateChanged(this.notifyRenderedFrameRateChanged.bind(this));
        this.session.onVideoTrackChanged(this.notifyVideoTrackChanged.bind(this));
        this.session.onCdnSwitch(this.notifyCdnSwitch.bind(this));
        this.session.onPlaybackTimelineUpdated(this.notifyPlaybackTimelineChanged.bind(this));
        this.session.onError(this._notifyError.bind(this));
        this.session.onPlayoutDataReceived(this.notifyPlayoutDataReceived.bind(this));
        this.session.onStateChanged(this.notifyStateChanged.bind(this));
        this.session.onSeekStarted(this.notifySeekStarted.bind(this));
        this.session.onSeekEnded(this.notifySeekEnded.bind(this));
        this.session.onPlayStart(this.notifyPlayStart.bind(this));
        this.session.onWarning(this._notifyWarning.bind(this));
        this.session.onPinRequired(this.notifyPinRequired.bind(this));
        this.session.onPinSuccess(this.notifyPinSuccess.bind(this));
        this.session.onUserWaitStarted(this.notifyUserWaitStarted.bind(this));
        this.session.onUserWaitEnded(this.notifyUserWaitEnded.bind(this));
        this.session.onTimedMetadataReceived(this.notifyTimedMetadataReceived.bind(this));
        this.session.onSessionRetryStarted(this.notifySessionRetryStarted.bind(this));
        this.session.onSessionRetryEnded(this.notifySessionRetryEnded.bind(this));
        this.session.onSessionRestartStarted(this.notifySessionRestartStarted.bind(this));
        this.session.onSessionRestartEnded(this.notifySessionRestartEnded.bind(this));
        this.session.onVideoElementCreated(this.notifyVideoElementCreated.bind(this));
        this.session.onFullscreenChanged(this.notifyFullscreenChanged.bind(this));
        this.session.onClicked(this.notifyClicked.bind(this));
        this.session.onMuteChanged(this.notifyMuteChanged.bind(this));
        this.session.onVolumeChanged(this.notifyVolumeChanged.bind(this));
        this.session.onRebufferStart(this.notifyRebufferStart.bind(this));
        this.session.onRebufferEnd(this.notifyRebufferEnd.bind(this));
        this.session.onEndOfEventMarkerReceived(this.notifyEndOfEventMarkerReceived.bind(this));
    }
    _create_class(DeferredReportingSession, [
        {
            key: "destroy",
            value: function destroy() {
                this.adStartedObservable.unregisterObservers(this);
                this.adFinishedObservable.unregisterObservers(this);
                this.adBreakStartedObservable.unregisterObservers(this);
                this.adBreakFinishedObservable.unregisterObservers(this);
                this.adBreakDataReceivedObservable.unregisterObservers(this);
                this.adTrackingReceivedObservable.unregisterObservers(this);
                this.catchupSeekObservable.unregisterObservers(this);
                this.telemetryObservable.unregisterObservers(this);
                this.adPositionObservable.unregisterObservers(this);
                this.assetMetadataUpdateObservable.unregisterObservers(this);
                this.audioTrackWillChangeObservable.unregisterObservers(this);
                this.audioTrackChangedObservable.unregisterObservers(this);
                this.availableAudioTracksChangedObservable.unregisterObservers(this);
                this.availableSubtitlesTracksChangedObservable.unregisterObservers(this);
                this.bitrateChangedObservable.unregisterObservers(this);
                this.encodedFrameRateChangedObservable.unregisterObservers(this);
                this.renderedFrameRateChangedObservable.unregisterObservers(this);
                this.videoTrackChangedObservable.unregisterObservers(this);
                this.cdnSwitchObservable.unregisterObservers(this);
                this.onPlaybackTimelineObservable.unregisterObservers(this);
                this.errorObservable.unregisterObservers(this);
                this.playoutDataObservable.unregisterObservers(this);
                this.sessionEndedObservable.unregisterObservers(this);
                this.sessionStateObservable.unregisterObservers(this);
                this.rebufferStartObservable.unregisterObservers(this);
                this.rebufferEndObservable.unregisterObservers(this);
                this.streamMetadataReceivedObservable.unregisterObservers(this);
                this.playStartObservable.unregisterObservers(this);
                this.seekStartedObservable.unregisterObservers(this);
                this.seekEndedObservable.unregisterObservers(this);
                this.timedMetadataReceivedObservable.unregisterObservers(this);
                this.subtitlesTextChangedObservable.unregisterObservers(this);
                this.subtitlesTrackChangedObservable.unregisterObservers(this);
                this.bitrateCapChangedObservable.unregisterObservers(this);
                this.bitrateCapRequestedObservable.unregisterObservers(this);
                this.volumeChangedObservable.unregisterObservers(this);
                this.warningObservable.unregisterObservers(this);
                this.eventBoundaryObservable.unregisterObservers(this);
                this.pinRequiredObservable.unregisterObservers(this);
                this.pinSuccessObservable.unregisterObservers(this);
                this.userWaitStartedObservable.unregisterObservers(this);
                this.userWaitEndedObservable.unregisterObservers(this);
                this.videoElementCreatedObservable.unregisterObservers(this);
                this.fullscreenChangedObservable.unregisterObservers(this);
                this.clickedObservable.unregisterObservers(this);
                this.muteChangedObservable.unregisterObservers(this);
                this.sessionRetryStartedObservable.unregisterObservers(this);
                this.sessionRetryEndedObservable.unregisterObservers(this);
                this.sessionRestartStartedObservable.unregisterObservers(this);
                this.sessionRestartEndedObservable.unregisterObservers(this);
            }
        },
        {
            key: "playerVersion",
            get: function get() {
                return this.session.playerVersion;
            }
        },
        {
            key: "onAdFinished",
            value: function onAdFinished(callback) {
                this.adFinishedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAdStarted",
            value: function onAdStarted(callback) {
                this.adStartedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAdBreakFinished",
            value: function onAdBreakFinished(callback) {
                this.adBreakFinishedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAdBreakStarted",
            value: function onAdBreakStarted(callback) {
                this.adBreakStartedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAdBreakDataReceived",
            value: function onAdBreakDataReceived(callback) {
                this.adBreakDataReceivedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAdTrackingReceived",
            value: function onAdTrackingReceived(callback) {
                this.adTrackingReceivedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onCatchupSeek",
            value: function onCatchupSeek(callback) {
                this.catchupSeekObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAdPositionChanged",
            value: function onAdPositionChanged(callback) {
                this.adPositionObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onTelemetry",
            value: function onTelemetry(callback) {
                this.telemetryObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAssetMetadataUpdated",
            value: function onAssetMetadataUpdated(callback) {
                this.assetMetadataUpdateObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAudioTrackWillChange",
            value: function onAudioTrackWillChange(callback) {
                this.audioTrackWillChangeObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAudioTrackChanged",
            value: function onAudioTrackChanged(callback) {
                this.audioTrackChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAvailableAudioTracksChanged",
            value: function onAvailableAudioTracksChanged(callback) {
                return this.availableAudioTracksChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAvailableSubtitlesTracksChanged",
            value: function onAvailableSubtitlesTracksChanged(callback) {
                return this.availableSubtitlesTracksChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onBitrateChanged",
            value: function onBitrateChanged(callback) {
                this.bitrateChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onEncodedFrameRateChanged",
            value: function onEncodedFrameRateChanged(callback) {
                this.encodedFrameRateChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onRenderedFrameRateChanged",
            value: function onRenderedFrameRateChanged(callback) {
                this.renderedFrameRateChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onVideoTrackChanged",
            value: function onVideoTrackChanged(callback) {
                this.videoTrackChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onCdnSwitch",
            value: function onCdnSwitch(callback) {
                this.cdnSwitchObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onPlaybackTimelineUpdated",
            value: function onPlaybackTimelineUpdated(callback) {
                this.onPlaybackTimelineObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onError",
            value: function onError(callback) {
                this.errorObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onPlayoutDataReceived",
            value: function onPlayoutDataReceived(callback) {
                this.playoutDataObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onSessionEnded",
            value: function onSessionEnded(callback) {
                this.sessionEndedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onStateChanged",
            value: function onStateChanged(callback) {
                this.sessionStateObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onRebufferStart",
            value: function onRebufferStart(callback) {
                var _this_rebufferStartObservable;
                (_this_rebufferStartObservable = this.rebufferStartObservable) === null || _this_rebufferStartObservable === void 0 ? void 0 : _this_rebufferStartObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onRebufferEnd",
            value: function onRebufferEnd(callback) {
                var _this_rebufferEndObservable;
                (_this_rebufferEndObservable = this.rebufferEndObservable) === null || _this_rebufferEndObservable === void 0 ? void 0 : _this_rebufferEndObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onSessionRetryStarted",
            value: function onSessionRetryStarted(callback) {
                this.sessionRetryStartedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onSessionRetryEnded",
            value: function onSessionRetryEnded(callback) {
                this.sessionRetryEndedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onSessionRestartStarted",
            value: function onSessionRestartStarted(callback) {
                this.sessionRestartStartedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onSessionRestartEnded",
            value: function onSessionRestartEnded(callback) {
                this.sessionRestartEndedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onStreamMetadataReceived",
            value: function onStreamMetadataReceived(callback) {
                this.streamMetadataReceivedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onPlayStart",
            value: function onPlayStart(callback) {
                this.playStartObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onSeekStarted",
            value: function onSeekStarted(callback) {
                this.seekStartedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onSeekEnded",
            value: function onSeekEnded(callback) {
                this.seekEndedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onTimedMetadataReceived",
            value: function onTimedMetadataReceived(callback) {
                return this.timedMetadataReceivedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onSubtitleCuesChanged",
            value: function onSubtitleCuesChanged(callback) {
                this.subtitlesTextChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onSubtitlesTrackChanged",
            value: function onSubtitlesTrackChanged(callback) {
                this.subtitlesTrackChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onBitrateCapChanged",
            value: function onBitrateCapChanged(callback) {
                this.bitrateCapChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onBitrateCapRequested",
            value: function onBitrateCapRequested(callback) {
                this.bitrateCapRequestedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onVolumeChanged",
            value: function onVolumeChanged(callback) {
                this.volumeChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onWarning",
            value: function onWarning(callback) {
                this.warningObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onEventBoundary",
            value: function onEventBoundary(callback) {
                this.eventBoundaryObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onPinRequired",
            value: function onPinRequired(callback) {
                this.pinRequiredObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onPinSuccess",
            value: function onPinSuccess(callback) {
                this.pinSuccessObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onUserWaitStarted",
            value: function onUserWaitStarted(callback) {
                this.userWaitStartedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onUserWaitEnded",
            value: function onUserWaitEnded(callback) {
                this.userWaitEndedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onVideoElementCreated",
            value: function onVideoElementCreated(callback) {
                this.videoElementCreatedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onFullscreenChanged",
            value: function onFullscreenChanged(callback) {
                this.fullscreenChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onClicked",
            value: function onClicked(callback) {
                this.clickedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onMuteChanged",
            value: function onMuteChanged(callback) {
                this.muteChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onEndOfEventMarkerReceived",
            value: function onEndOfEventMarkerReceived(callback) {
                this.endOfEventMarkerReceivedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "getAdvertsManager",
            value: function getAdvertsManager() {
                return this.session.getAdvertsManager();
            }
        },
        {
            key: "getContentTimePosition",
            value: function getContentTimePosition() {
                return this.session.getContentTimePosition();
            }
        },
        {
            key: "getPrefetchStage",
            value: function getPrefetchStage() {
                return this.session.getPrefetchStage();
            }
        },
        {
            key: "isPrefetchedSession",
            value: function isPrefetchedSession() {
                return this.session.isPrefetchedSession();
            }
        },
        {
            key: "notifyAssetMetadataUpdated",
            value: function notifyAssetMetadataUpdated(assetMetadata) {
                this.assetMetadataUpdateObservable.notifyObservers(assetMetadata);
            }
        },
        {
            key: "notifyAdFinished",
            value: function notifyAdFinished(ad) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.adFinishedObservable.notifyObservers(ad);
                });
            }
        },
        {
            key: "notifyTelemetry",
            value: function notifyTelemetry(telemetryEvent) {
                this.telemetryObservable.notifyObservers(telemetryEvent);
            }
        },
        {
            key: "notifyAdStarted",
            value: function notifyAdStarted(ad) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.adStartedObservable.notifyObservers(ad);
                });
            }
        },
        {
            key: "notifyAdBreakFinished",
            value: function notifyAdBreakFinished(adBreak) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.adBreakFinishedObservable.notifyObservers(adBreak);
                });
            }
        },
        {
            key: "notifyAdBreakStarted",
            value: function notifyAdBreakStarted(adBreak) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.adBreakStartedObservable.notifyObservers(adBreak);
                });
            }
        },
        {
            key: "notifyAdBreakDataReceived",
            value: function notifyAdBreakDataReceived(adBreaks) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.adBreakDataReceivedObservable.notifyObservers(adBreaks);
                });
            }
        },
        {
            key: "notifyAdTrackingReceived",
            value: function notifyAdTrackingReceived(adBreaks) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.adTrackingReceivedObservable.notifyObservers(adBreaks);
                });
            }
        },
        {
            key: "notifyCatchupSeek",
            value: function notifyCatchupSeek(catchupSeek) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.catchupSeekObservable.notifyObservers(catchupSeek);
                });
            }
        },
        {
            key: "notifyAdPositionChanged",
            value: function notifyAdPositionChanged(adPosition) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.adPositionObservable.notifyObservers(adPosition);
                });
            }
        },
        {
            key: "notifyAudioTrackWillChange",
            value: function notifyAudioTrackWillChange(trackId) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.audioTrackWillChangeObservable.notifyObservers("".concat(trackId));
                });
            }
        },
        {
            key: "notifyBitrateChanged",
            value: function notifyBitrateChanged(bitRateLevel) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.bitrateChangedObservable.notifyObservers(bitRateLevel);
                });
            }
        },
        {
            key: "notifyEncodedFrameRateChanged",
            value: function notifyEncodedFrameRateChanged(frameRate) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.encodedFrameRateChangedObservable.notifyObservers(frameRate);
                });
            }
        },
        {
            key: "notifyRenderedFrameRateChanged",
            value: function notifyRenderedFrameRateChanged(frameRate) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.renderedFrameRateChangedObservable.notifyObservers(frameRate);
                });
            }
        },
        {
            key: "notifyVideoTrackChanged",
            value: function notifyVideoTrackChanged(videoTrack) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.videoTrackChangedObservable.notifyObservers(videoTrack);
                });
            }
        },
        {
            key: "notifyCdnSwitch",
            value: function notifyCdnSwitch(cdnSwitchEvent) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.cdnSwitchObservable.notifyObservers(cdnSwitchEvent);
                });
            }
        },
        {
            key: "notifyPlaybackTimelineChanged",
            value: function notifyPlaybackTimelineChanged(playbackTimeline) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.onPlaybackTimelineObservable.notifyObservers(playbackTimeline);
                });
            }
        },
        {
            key: "_notifyError",
            value: function _notifyError(error) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.errorObservable.notifyObservers(error);
                });
            }
        },
        {
            key: "notifyPlayoutDataReceived",
            value: function notifyPlayoutDataReceived(playoutData) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.playoutDataObservable.notifyObservers(playoutData);
                });
            }
        },
        {
            key: "notifyStateChanged",
            value: function notifyStateChanged(internalSessionState) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.sessionStateObservable.notifyObservers(internalSessionState);
                });
            }
        },
        {
            key: "notifySessionRetryStarted",
            value: function notifySessionRetryStarted(error) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.sessionRetryStartedObservable.notifyObservers(error);
                });
            }
        },
        {
            key: "notifySessionRetryEnded",
            value: function notifySessionRetryEnded(error) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.sessionRetryEndedObservable.notifyObservers(error);
                });
            }
        },
        {
            key: "notifySessionRestartStarted",
            value: function notifySessionRestartStarted() {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.sessionRestartStartedObservable.notifyObservers();
                });
            }
        },
        {
            key: "notifySessionRestartEnded",
            value: function notifySessionRestartEnded() {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.sessionRestartEndedObservable.notifyObservers();
                });
            }
        },
        {
            key: "notifyVideoElementCreated",
            value: function notifyVideoElementCreated(videoElement) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.videoElementCreatedObservable.notifyObservers(videoElement);
                });
            }
        },
        {
            key: "notifyFullscreenChanged",
            value: function notifyFullscreenChanged(isFullscreen) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.fullscreenChangedObservable.notifyObservers(isFullscreen);
                });
            }
        },
        {
            key: "notifyClicked",
            value: function notifyClicked() {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.clickedObservable.notifyObservers();
                });
            }
        },
        {
            key: "notifyMuteChanged",
            value: function notifyMuteChanged(isMuted) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.muteChangedObservable.notifyObservers(isMuted);
                });
            }
        },
        {
            key: "notifyVolumeChanged",
            value: function notifyVolumeChanged(volume) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.volumeChangedObservable.notifyObservers(volume);
                });
            }
        },
        {
            key: "notifySeekStarted",
            value: function notifySeekStarted(position) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.seekStartedObservable.notifyObservers(position);
                });
            }
        },
        {
            key: "notifySeekEnded",
            value: function notifySeekEnded() {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.seekEndedObservable.notifyObservers();
                });
            }
        },
        {
            key: "notifyPlayStart",
            value: function notifyPlayStart() {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.playStartObservable.notifyObservers();
                });
            }
        },
        {
            key: "_notifyWarning",
            value: function _notifyWarning(warning) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.warningObservable.notifyObservers(warning);
                });
            }
        },
        {
            key: "notifyPinRequired",
            value: function notifyPinRequired(pinRequiredCause) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.pinRequiredObservable.notifyObservers(pinRequiredCause);
                });
            }
        },
        {
            key: "notifyPinSuccess",
            value: function notifyPinSuccess() {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.pinSuccessObservable.notifyObservers();
                });
            }
        },
        {
            key: "notifyUserWaitStarted",
            value: function notifyUserWaitStarted() {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.userWaitStartedObservable.notifyObservers();
                });
            }
        },
        {
            key: "notifyUserWaitEnded",
            value: function notifyUserWaitEnded() {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.userWaitEndedObservable.notifyObservers();
                });
            }
        },
        {
            key: "notifyTimedMetadataReceived",
            value: function notifyTimedMetadataReceived() {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.timedMetadataReceivedObservable.notifyObservers();
                });
            }
        },
        {
            key: "notifyRebufferStart",
            value: function notifyRebufferStart(_, currentPosition) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.rebufferStartObservable.notifyObservers(undefined, currentPosition);
                });
            }
        },
        {
            key: "notifyRebufferEnd",
            value: function notifyRebufferEnd(_, currentPosition) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.rebufferEndObservable.notifyObservers(undefined, currentPosition);
                });
            }
        },
        {
            key: "notifyEndOfEventMarkerReceived",
            value: function notifyEndOfEventMarkerReceived(eventTime) {
                var _this = this;
                this.eventQueue.push(function() {
                    return _this.endOfEventMarkerReceivedObservable.notifyObservers(eventTime);
                });
            }
        },
        {
            key: "notifyWarning",
            value: function notifyWarning(code, message) {
                this.session.notifyWarning(code, message);
            }
        }
    ]);
    return DeferredReportingSession;
}();

//# sourceMappingURL=deferred-reporting-session.js.map